export type TClientPep = {
  fullName: string | null;
  pepPosition: string | null;
  publicFunctionsStartDate: string | null;
  publicFunctionsEndDate: string | null;
  lastName?: string;
  firstName?: string;
  middleName?: string;
};

export type TRelatedPep = TClientPep & {
  identificationNumber: string | null;
  foreignTaxNumber: string | null;
  citizenshipCountry: TSelectItem;
  residenceCountry: TSelectItem;
};

export type TSelectItem = {
  value: string | null;
  label: string | null;
};

export type TPepEntity = {
  isPepsAbsent: boolean;
  fullName: string;
  isPep: boolean;
  isFamilyPep: boolean;
  isPepRelatedPerson: boolean;
  pepInfo: TClientPep | null;
  familyPepsInfo: TRelatedPep[] | null;
  pepRelatedPersonsInfo: TRelatedPep[] | null;
  hasForeignTaxResidency?: boolean;
  lastName?: string | null;
  firstName?: string | null;
  middleName?: string | null;
  appeals?: TSelectItem | null;
  jurisdictions?: TJurisdictions[] | null;
  accounts: TAccount[] | null;
  type?: string;
};

export type TJurisdictions = {
  country: TSelectItem | null;
  identifyCode: null;
  reason: null;
  explanation: string | null;
};

export type TAccount = {
  iban: string | null;
  openDate: Date | string | null;
};

export type TFatca = {
  isForeignFinancialUnderFATCA: boolean | null;
  fullName: string | null;
  fullNameInEng: string | null;
  tinType: string | null;
  tin: string | null;
  refutationDocType: string | null;
  explanation: {
    usBirthAddress: string | null;
    message: string | null;
  };
};

export type TPepInStore = {
  additionalInformation: TPepEntity[];
  fatca: TFatca;
  type: string;
};

export type TAdditionalInformationFormValues = {
  additionalInformation: TPepEntity[];
  fatca: TFatca;
  isCompleted?: boolean;
};

export const emptyFatca: TFatca = {
  isForeignFinancialUnderFATCA: null,
  fullName: null,
  fullNameInEng: null,
  tinType: null,
  tin: null,
  refutationDocType: null,
  explanation: {
    usBirthAddress: null,
    message: null,
  },
};

export type TAdditionalInfoFormContentProps = {
  index: number;
};
